import { ApiModel } from '../../app-lite/api/models/api.model';

export class SystemActivityLogsCtrl {
  public beginDate    = '*';
  public companyId    = '*';
  public endDate      = '*';
  public timeDuration = 1;

  constructor (
    private $window    : ng.IWindowService,
    private API        : ApiModel
  ) {}

  print ( type : 'csv' | 'pdf' = 'pdf' ) : void {
    const url = `${
      this.API.url
    }/reports/jasper_system_activity_logs/${
      type
    }/${
      this.timeDuration || 1
    }/${
      this.companyId
    }/${
      this.beginDate
    }/${
      this.endDate
    }${
      type === 'pdf'
      ? '.pdf'
      : ''
    }`;

    this.$window.open(url, '_blank');
  };
}
